import React from 'react';

import { GrowthMetricCard, GrowthMetricCardProps } from './growth-metric-card';
import * as styles from './growth-metric-card.scss';

interface GrowthMetricCardsProps {
  metrics: GrowthMetricCardProps[];
}

export const GrowthMetricCards = ({ metrics }: GrowthMetricCardsProps) => {
  return (
    <div className={styles.growthMetricCards}>
      {metrics.map(metric => (
        <GrowthMetricCard key={metric.label} {...metric} />
      ))}
    </div>
  );
};
